<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("vincular-forma-pagamento") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button 
                    class="delete-btn" 
                    type="button" 
                    @click="fecharModal()"
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="formaPagamentoSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <br/>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
            <div class="pt-2 pb-2">
                <vs-select
                    :id="1"
                    ref="clienteInput"
                    :title="'cliente'"
                    :options="cliente"
                    v-model="idClienteSelecionado"
                    :search="loadCliente"
                    :onChange="updateCliente"
                    :placeholder="'cliente'"
                    :invalid="isNull(idClienteSelecionado)"
                    :loading="loadingCliente"
                />
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="formaPagto"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="formaPagamentoSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idFormaPagto === linha.idFormaPagto"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AssClienteFormaPagamentoB2BEmpresaService from "@/services/b2b/AssClienteFormaPagamentoB2BEmpresaService";
import AssFormaPagamentoEmpresaService from "@/services/vendas/empresa/abas/AssFormaPagamentoEmpresaService";
import { cpfcnpj } from "@/functions/masks";
import Message from "@/models/Message.js";

/* @70957 */
export default {
    props: {
        idEmpresa: 0,
    },
    data() {
        return {
            service: new AssClienteFormaPagamentoB2BEmpresaService(this.$http, this.$router),
            formaPagtoService: new AssFormaPagamentoEmpresaService(this.$http, this.$router),
            formaPagto: [],
            cliente:[],
            isLoading: false,
            loadingCliente: false,
            isEmpty: false,
            fields: [
                { key: 'descricao', width: null, sortable: true }
            ],
            formaPagamentoSelecionados: [],
            idClienteSelecionado: null,
            idformapagto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.loadCliente();
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.formaPagtoService.findAllNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idEmpresa,
                true,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.formaPagto = value;

                this.isEmpty = this.formaPagto.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        loadCliente(searchQuery) {
            this.loadingCliente = true;
            this.service
                .findAllCombo(this.$route.params.id, searchQuery)
                .then(this.mapCliente)
                .then((value) => {
                    this.cliente = value;
                })
                .catch((e) => {
                    console.log(e)
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.loadingCliente = false;
                });
        },
        updateCliente(cliente) {
            if (cliente) {
                this.idClienteSelecionado = cliente;
            } else {
                this.idClienteSelecionado = null;
            }
            setTimeout(() => {
                this.$forceUpdate();
            }, 5);
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idEmpresa: Number(this.idEmpresa),
                    idFormaPagto: m.idformapagto,
                    descricao: m.descricao
                };
            });
        },
        mapCliente(item){
            return item.content.map(({ idCliente, cnpjCpf, rsocial, nome, cidade, estado }) => {
                const nomeFormatado = `${cnpjCpf ? cpfcnpj(cnpjCpf) : 'Não informado'} - ${rsocial ? rsocial : nome} - ${cidade ? cidade : 'Não informado'}${estado ? `-${estado}` : ''}`
                
                return {
                    id: idCliente,
                    descricao: nomeFormatado,
                    label: nomeFormatado
                }
            })
        },
        mapToSave(data) {
            const idCliente = this.idClienteSelecionado && this.idClienteSelecionado.id
                ? this.idClienteSelecionado.id
                : null;

            return data.map(function (element) {
                return Object.assign({ idCliente: idCliente }, element);
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (!this.idClienteSelecionado || !this.idClienteSelecionado.id) {
                this.msgs.push(new Message("error", "msg-selecione-cliente", true));
                return;
            }
            if (this.formaPagamentoSelecionados.length > 0) {
                this.isLoading = true;
                
                const mappedData = this.mapToSave(this.formaPagamentoSelecionados);
                
                this.service.insertBulk(mappedData)
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch(() => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-forma-pagamento', true));
                this.isLoading = false;
            }
        },
        fecharModal() {
              this.$emit("fecharModal", true);
        },
    },
}
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
